import register from '@kpsys/angularjs-register';
import type {FactoryFunction} from 'typings/portaro.fe.types';
import UserFinancePanelComponent from './user-finance-panel.component';
import {UserFinanceServiceFactory} from './user-finance.factory';

/**
 * @ngdoc module
 * @name portaro.uc.user.components
 * @module portaro.uc.user.components
 */

export default register('portaro.uc.user.components')
    .factory((UserFinanceServiceFactory as FactoryFunction).factoryName, UserFinanceServiceFactory)
    .component(UserFinancePanelComponent.componentName, UserFinancePanelComponent)
    .name();
